"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _v = _interopRequireDefault(require("uuid/v4"));
var _get = _interopRequireDefault(require("lodash/get"));
var _flattenDeep = _interopRequireDefault(require("lodash/flattenDeep"));
var _filter = _interopRequireDefault(require("lodash/filter"));
var _reduce = _interopRequireDefault(require("lodash/reduce"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel"));
var _Input = _interopRequireDefault(require("@mui/material/Input"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Dropdown2 = require("../Dropdown");
var _FormControl = _interopRequireWildcard(require("../FormControl"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _EDSContext = require("../EDSContext/EDSContext");
var _IOSBodyScroll = _interopRequireDefault(require("./../IOSBodyScroll"));
var _styles = _interopRequireDefault(require("../styles"));
var _tokens = require("../styles/tokens");
var _ChevronDown = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronDown"));
var _excluded = ["aria-label", "children", "classes", "disabled", "error", "edsContext", "helperText", "id", "inputProps", "label", "multiple", "required", "value", "size", "onChange", "showSelectAll", "fullWidth", "FormControlProps", "FormHelperTextProps", "MenuProps", "innerRef"]; // MUI imports
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// select all selection states
var ALL = 0;
var INDETERMINATE = 1;
var NONE = 2;
var styles = function styles(theme) {
  return {
    selectRoot: {
      '& .MuiInputBase-input.MuiSelect-select': {
        paddingRight: '3.5rem',
        minHeight: 'auto'
      },
      '& .MuiInputBase-input.MuiNativeSelect-select': {
        paddingRight: '3.5rem',
        minHeight: 'auto'
      }
    },
    select: {
      backgroundColor: theme.palette.grey['100'],
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey['400'],
      borderRadius: _tokens.borderRadiusMedium,
      padding: _tokens.spacing50 + " 3.5rem " + _tokens.spacing30 + " " + _tokens.spacing40,
      lineHeight: '1.25rem',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      '&$disabled': {
        backgroundColor: theme.palette.grey['200'],
        cursor: 'not-allowed'
      },
      '&:focus': {
        backgroundColor: theme.palette.grey['100'],
        borderRadius: _tokens.borderRadiusMedium,
        boxShadow: _tokens.boxShadowFocus
      }
    },
    selectIcon: {
      '&:hover': {
        '& $icon': {
          fill: theme.palette.ctaColor.active
        }
      }
    },
    paper: {
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey[400],
      boxShadow: '0 0.125rem 0.0625rem -0.0625rem rgba(0, 0, 0, 0.12), 0 0.0625rem 0.0625rem 0 rgba(0, 0, 0, 0.14), 0 0.0625rem 0.1875rem 0 rgba(0, 0, 0, 0.21)',
      // this will flip to rtl when the dir is set to "rtl" in EDSApplication
      direction: 'ltr'
    },
    nativeSelect: {
      backgroundColor: theme.palette.grey['100'],
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey['400'],
      padding: _tokens.spacing50 + " 3.5rem " + _tokens.spacing30 + " " + _tokens.spacing40,
      lineHeight: '1.25rem',
      borderRadius: _tokens.borderRadiusMedium,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: 'calc(100% - 4.625rem)',
      height: 'auto',
      '&$disabled': {
        backgroundColor: theme.palette.grey['200'],
        cursor: 'not-allowed'
      },
      '&:focus': {
        backgroundColor: theme.palette.grey['100'],
        borderRadius: _tokens.borderRadiusMedium,
        boxShadow: _tokens.boxShadowFocus
      }
    },
    icon: {
      right: _tokens.spacing40,
      top: '1.1875rem',
      fill: theme.palette.grey['500']
    },
    inputLabelRoot: {
      cursor: 'text',
      fontWeight: theme.typography.fontWeightRegular,
      left: 2,
      zIndex: theme.zIndex.textFieldLabel,
      maxWidth: 'calc(100% - 1rem)',
      fontSize: _tokens.fontSizeLarge,
      color: theme.palette.grey['500'],
      pointerEvents: 'none'
    },
    inputLabelShrink: {
      top: '1.0625rem' // 17 px
    },
    disabled: {
      cursor: 'not-allowed'
    },
    zIndex: {
      zIndex: theme.zIndex.dropdown + 1
    },
    small: {
      fontSize: _tokens.fontSizeDefault,
      height: _tokens.heightInputFieldsSmall,
      '& $icon': {
        top: '0.75rem'
      },
      '& $inputLabelRoot': {
        top: '-0.75rem',
        fontSize: _tokens.fontSizeDefault
      },
      '& $select': {
        padding: '0.625rem 3.5rem 0.625rem 0.625rem',
        lineHeight: '1rem'
      },
      '& $nativeSelect': {
        padding: '0.625rem 3.5rem 0.625rem 0.625rem',
        lineHeight: '1rem'
      }
    },
    inputLabelSmall: {
      top: '-0.43rem',
      left: '-0.14rem',
      fontSize: _tokens.fontSizeDefault,
      '&[data-shrink=true]': {
        display: 'none'
      }
    },
    error: {
      border: _tokens.borderWidthThick + " solid " + theme.palette.status.error.fill,
      '&:focus': {
        boxShadow: "0 0 0 " + _tokens.borderWidthThin + " " + _tokens.colorFillAlertError,
        '-webkit-box-shadow': "0 0 0 " + _tokens.borderWidthThin + " " + _tokens.colorFillAlertError,
        '-moz-box-shadow:': "0 0 0 " + _tokens.borderWidthThin + " " + _tokens.colorFillAlertError
      }
    },
    formControlWidth: {
      maxWidth: _tokens.widthInputFields
    },
    resetVerticalAlign: {
      verticalAlign: 'middle' // fixes extra space added at the bottom of dropdowns in firefox
    }
  };
};
var menuListClassName = 'menu-list';

/**
 * Use `Dropdown` to make selections from a list.
 * @done true
 * @updated v7.17.0
 * @versionAdded v0.0.10
 * @examples
 *  ControlledDropdownExample
 *  ErrorDropdownExample
 *  FullWidthDropdownExample
 *  IconDropdownExample
 *  LongTextDropdownExample
 *  MultiSelectDropdownExample
 *  SelectAllDropdownExample
 *  PerformanceTestDropdownExample
 *  NativeExample
 */
var Dropdown = /*#__PURE__*/function (_React$Component) {
  function Dropdown(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;

    // the internal value of the 'select all' item
    _this.onDropDownOpen = function (e) {
      var onOpen = _this.props.onOpen;
      _this.setState({
        isMenuOpen: true
      });
      _IOSBodyScroll.default.lock("." + menuListClassName);
      onOpen && onOpen(e);
    };
    _this.onDropDownClose = function (e) {
      var onClose = _this.props.onClose;
      _this.setState({
        isMenuOpen: false
      });
      _IOSBodyScroll.default.unlock();
      onClose && onClose(e);
    };
    _this.getSelectionStatusString = function () {
      var edsContext = _this.props.edsContext;
      if (_this.state.selectionState === ALL) {
        return edsContext.formatMessage('component.Dropdown.all');
      } else if (_this.state.selectionState === INDETERMINATE) {
        return edsContext.formatMessage('component.Dropdown.intermediate');
      } else if (_this.state.selectionState === NONE) {
        return edsContext.formatMessage('component.Dropdown.none');
      }
    };
    _this.getCountString = function () {
      // add the current selection count to the label
      var localValue = (0, _isNil.default)(_this.props.value) ? '' : _this.props.value;
      if (localValue && _this.state.allItems) {
        if (_this.props.edsContext.dir === 'ltr') {
          return _this.props.value.length + "/" + Object.keys(_this.state.allItems).length;
        } else {
          return Object.keys(_this.state.allItems).length + "/" + _this.props.value.length;
        }
      }
    };
    _this.selectAllValue = (0, _v.default)();
    _this.state = {
      selectionState: NONE,
      allItems: {},
      isMenuOpen: false
    };
    _this.onDropDownOpen = _this.onDropDownOpen.bind(_this);
    _this.onDropDownClose = _this.onDropDownClose.bind(_this);
    _this.getSelectionStatusString = _this.getSelectionStatusString.bind(_this);
    return _this;
  }

  /**
   * Called when the dropdown value changes
   *
   * @param {Event} event   The event that spurred this callback
   * @param {object} child  The react element that was selected
   */
  (0, _inheritsLoose2.default)(Dropdown, _React$Component);
  var _proto = Dropdown.prototype;
  _proto.handleChange = function handleChange(event, child) {
    var _this2 = this;
    // if the user click the 'select all' item in a multi-select dropdown
    if (this.props.multiple && event.target.value.indexOf(this.selectAllValue) > -1) {
      // if no items are selected, select everything; otherwise unselect everything
      var newState = this.state.selectionState === NONE ? ALL : NONE;

      // set the new select all state
      this.setState({
        selectionState: newState
      }, function () {
        // either select or unselect everything (overriding the value in the
        // event with the results of doing so)
        if (_this2.state.selectionState === ALL) {
          event.target.value = Object.keys(_this2.state.allItems);
        } else {
          event.target.value = [];
        }

        // let the caller know
        _this2.props.onChange && _this2.props.onChange(event, child);
      });
    } else {
      this.props.onChange && this.props.onChange(event, child);
    }
  }

  /**
   * Grab the label/value of each item
   */;
  _proto.objectifyItems = function objectifyItems() {
    // grab all the dropdown items

    var filteredDropdownItems = (0, _filter.default)((0, _flattenDeep.default)(this.props.children), function (item) {
      return (0, _get.default)(item, 'type.muiName') === 'DropdownItem';
    });
    return (0, _reduce.default)(filteredDropdownItems, function (mapping, item) {
      mapping[item.props.value] = item.props.label;
      return mapping;
    }, {});
  }

  /**
   * Render a single value.
   *
   * @param {*} val The value to render
   * @return        The rendered value
   */;
  _proto.renderSingleValue = function renderSingleValue(val) {
    return this.state.allItems[val];
  }

  /**
   * Render multiple values.
   *
   * @param {Array.<*>} values The values to render
   * @return                   The rendered values
   */;
  _proto.renderMultipleValues = function renderMultipleValues(values) {
    var _this3 = this;
    return values.map(function (val) {
      return _this3.renderSingleValue(val);
    }).join(', ');
  };
  _proto.componentDidMount = function componentDidMount() {
    // retain a catalog of each dropdown item
    this.setState({
      allItems: this.objectifyItems()
    });

    // make sure a label was provided, in some form
    if ((0, _isNil.default)(this.props.label) && ((0, _isNil.default)(this.props.inputProps) || (0, _isNil.default)(this.props.inputProps['aria-label']))) {
      console.warn('Dropdown should have either a label or an aria-label (for accessibility purposes)');
    }
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // if the list of items has changed, update our internal catalog
    var itemsHaveChanged = (0, _get.default)(this.props, 'children.length', 0) !== (0, _get.default)(prevProps, 'children.length', 0) || !(0, _isEqual.default)(this.objectifyItems(), this.state.allItems);
    if (itemsHaveChanged) {
      this.setState({
        allItems: this.objectifyItems()
      });
    }

    // if the select-all item is visible, update it based on current selections
    if (this.props.multiple && this.props.showSelectAll) {
      var selectionState = NONE;
      if (this.props.value.length === Object.keys(this.state.allItems).length) {
        selectionState = ALL;
      } else if (this.props.value.length > 0) {
        selectionState = INDETERMINATE;
      }

      // if selection state changed, update it
      if (this.state.selectionState !== selectionState) {
        this.setState({
          selectionState: selectionState
        });
      }
    }
  };
  _proto.render = function render() {
    var _classNames, _classNames2, _classNames3, _classNames4, _classNames5;
    var _this$props = this.props,
      ariaLabel = _this$props['aria-label'],
      childrenProp = _this$props.children,
      classes = _this$props.classes,
      disabled = _this$props.disabled,
      error = _this$props.error,
      edsContext = _this$props.edsContext,
      helperText = _this$props.helperText,
      id = _this$props.id,
      inputProps = _this$props.inputProps,
      labelProp = _this$props.label,
      multiple = _this$props.multiple,
      required = _this$props.required,
      value = _this$props.value,
      size = _this$props.size,
      onChange = _this$props.onChange,
      showSelectAll = _this$props.showSelectAll,
      fullWidth = _this$props.fullWidth,
      FormControlProps = _this$props.FormControlProps,
      FormHelperTextProps = _this$props.FormHelperTextProps,
      MenuProps = _this$props.MenuProps,
      innerRef = _this$props.innerRef,
      rest = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
    var cleanedId = id || (0, _v.default)();
    var selectLabelId = cleanedId + '_label';
    var selectValueId = cleanedId + '_value';
    var newInputProps = (0, _extends2.default)({}, inputProps, {
      id: cleanedId,
      classes: {
        formControl: classes.resetVerticalAlign
      }
    });
    var ariaRequired = required && !disabled ? {
      'aria-required': true
    } : {};
    if (ariaLabel) {
      newInputProps['aria-label'] = ariaLabel;
    }
    var children = childrenProp;
    var label = labelProp;

    // we do this to handle a bug within MUI - if the initial value is nil, then the label does not correctly
    // shrink out of the way when an item is selected. so we set the initial value to empty string instead, which
    // appears to solve the issue
    var localValue = (0, _isNil.default)(value) ? '' : value;
    if (multiple) {
      children = _react.default.Children.map(childrenProp, function (child) {
        return /*#__PURE__*/(0, _react.cloneElement)(child, {
          multiple: true
        });
      });
    }
    return /*#__PURE__*/_react.default.createElement(_FormControl.default, (0, _extends2.default)({
      className: (0, _classnames.default)(classes.selectRoot, (_classNames = {}, _classNames[classes.formControlWidth] = !fullWidth, _classNames))
    }, FormControlProps), /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
      id: selectLabelId,
      classes: {
        root: classes.inputLabelRoot,
        shrink: classes.inputLabelShrink,
        disabled: (0, _classnames.default)(classes.disabled, classes.zIndex)
      },
      disabled: disabled,
      htmlFor: this.props.native ? selectValueId : undefined,
      className: (0, _classnames.default)((_classNames2 = {}, _classNames2[classes.inputLabelSmall] = size === 'small', _classNames2))
    }, label, " ", required ? /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, ' * ') : '', multiple && /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true"
    }, "(", this.getCountString(), ")"), multiple && /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "srOnly"
    }, ", ", "" + edsContext.formatMessage('component.Dropdown.totalSelected', {
      count: this.props.value.length,
      total: Object.keys(this.state.allItems).length
    }))), /*#__PURE__*/_react.default.createElement(_Select.default, (0, _extends2.default)({
      className: (0, _classnames.default)((_classNames3 = {}, _classNames3[classes.small] = size === 'small', _classNames3[classes.selectIcon] = !disabled, _classNames3)),
      classes: {
        select: (0, _classnames.default)((_classNames4 = {}, _classNames4[classes.select] = !this.props.native, _classNames4[classes.nativeSelect] = this.props.native, _classNames4[classes.error] = error, _classNames4)),
        icon: classes.icon,
        disabled: classes.disabled
      },
      onChange: this.handleChange.bind(this),
      disabled: disabled,
      disableUnderline: true,
      IconComponent: _ChevronDown.default,
      input: /*#__PURE__*/_react.default.createElement(_Input.default, newInputProps),
      labelId: selectLabelId,
      id: selectValueId,
      MenuProps: (0, _extends2.default)({
        MenuListProps: {
          disablePadding: true,
          className: menuListClassName,
          'aria-multiselectable': multiple
        },
        classes: {
          root: (0, _classnames.default)((_classNames5 = {}, _classNames5[classes.menuRoot] = size !== 'small', _classNames5[classes.menuRootSmall] = size === 'small', _classNames5)),
          paper: classes.paper
        },
        anchorOrigin: {
          horizontal: edsContext.dir === 'ltr' ? 'left' : 'right',
          vertical: 'bottom'
        },
        transformOrigin: {
          horizontal: edsContext.dir === 'ltr' ? 'left' : 'right',
          vertical: -4 // adds spacing between the Menu and TextField
        },
        // this overrides the dropdown Popover's margin threshold, which
        // by default has a 16px offset from the side of the page
        //
        // https://github.com/mui/material-ui/issues/35155
        marginThreshold: 0
      }, MenuProps),
      multiple: multiple,
      renderValue: multiple ? this.renderMultipleValues.bind(this) : this.renderSingleValue.bind(this),
      value: localValue,
      ref: innerRef
    }, rest, {
      onOpen: this.onDropDownOpen,
      onClose: this.onDropDownClose,
      SelectDisplayProps: (0, _extends2.default)({
        'aria-expanded': !(0, _isNil.default)(this.props.open) ? this.props.open : this.state.isMenuOpen
      }, ariaRequired),
      inputProps: (0, _extends2.default)({}, ariaRequired)
    }), showSelectAll && /*#__PURE__*/_react.default.createElement(_Dropdown2.DropdownItem, {
      label: edsContext.formatMessage('component.Dropdown.selectAll'),
      selectAll: true,
      multiple: true,
      value: this.selectAllValue,
      id: cleanedId
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      indeterminate: this.state.selectionState === INDETERMINATE,
      checked: this.state.selectionState !== NONE,
      inputProps: {
        'aria-labelledby': cleanedId + "-item-text select-all-selection-status"
      }
    }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      "aria-hidden": "true",
      id: "select-all-selection-status",
      variant: "srOnly"
    }, ", ", this.getSelectionStatusString(), " ")), children), helperText && /*#__PURE__*/_react.default.createElement(_FormControl.FormHelperText, (0, _extends2.default)({
      className: size === 'medium' && !this.props.native ? classes.ffErrorTextAdjuster : null,
      error: error,
      id: cleanedId + "_HelperText"
    }, FormHelperTextProps), helperText)));
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    // Just making sure to unlock the body scroll
    _IOSBodyScroll.default.unlock();
  };
  return Dropdown;
}(_react.default.Component);
/**
 * The following should be used to enable Tooltip hover once bugs have been tested
 *
    <Tooltip
        disableFocusListener
        enterDelay={1000}
        enterTouchDelay={1000}
        leaveTouchDelay={500}
        id={`${id}_Tooltip`}
        title={multiple ? value.join(', ') : value}
    >
        <Select></Select>
    </Tooltip>
 */
Dropdown.muiName = 'Dropdown';
Dropdown.propTypes = {
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes.default.bool,
  /**
   * The elements to populate the select with.
   *
   * - If `native` it true, these must be `option` elements
   * - if `native` is false, these must be `DropdownItem` elements
   */
  children: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * If `true`, the dropdown will be disabled.
   */
  disabled: _propTypes.default.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: _propTypes.default.bool,
  /**
   * If `true`, the dropdown will display in an error state
   */
  error: _propTypes.default.bool,
  /**
   * Properties applied to the [`FormControl`](#/components/FormControl) element.
   */
  FormControlProps: _propTypes.default.object,
  /**
   * Properties applied to the [`FormHelperText`](#/components/FormControl) element.
   */
  FormHelperTextProps: _propTypes.default.object,
  /**
   * If `true`, the dropdown will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,
  /**
   * Text to be displayed by the FormHelperText component
   */
  helperText: _propTypes.default.string,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
  /**
   * Id assigned to the input element and referenced by label element
   */
  id: _propTypes.default.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes.default.element,
  /**
   * Attributes applied to the `input` element. When `native` is `true`,
   * the attributes are applied on the `select` element.
   */
  inputProps: _propTypes.default.object,
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  /**
   * @ignore
   */
  innerRef: _propTypes.default.func,
  /**
   * Label that is attached to the `Dropdown`
   */
  label: _propTypes.default.string,
  /**
   * @ignore
   * Aria-label for 'Select' element
   */
  'aria-label': _propTypes.default.node,
  /**
   * Properties applied to the [`Menu`](https://material-ui.com/api/menu/) element.
   */
  MenuProps: _propTypes.default.object,
  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   * This feature will only work if `native` is `false`.
   */
  multiple: _propTypes.default.bool,
  /**
   * If `true`, the component will be using a native `select` element.
   * Be sure to use the `option` element to create dropdown items when
   * `native` is set to `true`, instead of our `DropdownItem` component.
   */
  native: _propTypes.default.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * Signature:
   * `function(event: SelectChangeEvent<T>, child?: object) => void`
   * `event`: The event source of the callback. You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * child: The React element that was selected when `native` is `false` (default).
   */
  onChange: _propTypes.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * Signature:
   * ```
   * function(event: object) => void
   * ```
   * _event_: The event source of the callback
   */
  onClose: _propTypes.default.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * Signature:
   * ```
   * function(event: object) => void
   * ```
   *
   * _event_: The event source of the callback
   */
  onOpen: _propTypes.default.func,
  /**
   * Control `select` open state. You can only use it when the `native` property is `false` (default).
   *
   * If you use `onOpen` or `onClose` callbacks, you must always provide the `open` prop.
   */
  open: _propTypes.default.bool,
  /**
   * Render the selected value.
   *
   * Signature:
   * ```
   * function(value: any) => ReactElement
   * ```
   *
   * _value_: The `value` provided to the component.
   */
  renderValue: _propTypes.default.func,
  /**
   * Whether this dropdown is required.
   */
  required: _propTypes.default.bool,
  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes.default.object,
  /**
   * Whether to provide a "select all" option for multi-select dropdowns
   */
  showSelectAll: _propTypes.default.bool,
  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))]),
  /**
   * The size of the Dropdown. Small size is recommended to be used within the `TableEditableCell` component.
   */
  size: _propTypes.default.oneOf(['small', 'medium'])
};
Dropdown.defaultProps = {
  autoWidth: false,
  displayEmpty: false,
  fullWidth: false,
  multiple: false,
  required: false,
  showSelectAll: false,
  size: 'medium',
  value: ''
};
var DropdownInternal = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles)(Dropdown));
Dropdown.displayName = 'Dropdown';
var _default = exports.default = /*#__PURE__*/_react.default.forwardRef(function WrappedDropdown(props, ref) {
  return /*#__PURE__*/_react.default.createElement(DropdownInternal, (0, _extends2.default)({}, props, {
    innerRef: ref
  }));
});